export const getBSWholeWheatPitaBreadPackage = newProduct => {
  const newBSWholeWheatPitaBreadPackage = {
    UPC: newProduct.UPC,
    Size: newProduct.Size,
  }
  return newBSWholeWheatPitaBreadPackage
}

export const updateBSWholeWheatPitaBreadPackage = newProduct => {
  const newBSWholeWheatPitaBreadPackage = {
    UPC: newProduct.UPC,
    Size: newProduct.Size,
  }
  return newBSWholeWheatPitaBreadPackage
}
